// sort-imports-ignore
// Kept first, hence no import sorting in this file: it takes a link's token out of the URL before
// the app, and so PostHog, loads.
import '@/shared/utils/linkToken';

import { createRoot } from 'react-dom/client';

import App from './App';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(<App />);
